package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetClubSeasonsResponse(
    val data: List<GetClubSeasonData> = emptyList(),
)

@Serializable
data class GetClubSeasonData(
    @SerialName("_attachments")
    val attachments: String = "",
    @SerialName("_etag")
    val etag: String = "",
    @SerialName("_rid")
    val rid: String = "",
    @SerialName("_self")
    val self: String = "",
    @SerialName("_ts")
    val ts: Long = 0L,
    val createdAt: String = "",
    val endDate: String = "",
    val id: String = "",
    val name: String = "",
    val organization: String = "",
    val startDate: String = "",
    val status: String = "",
    val type: String = "",
    val updatedAt: String? = null,
)

data class SeasonUi(
    val id: String,
    val name: String,
    val status: String,
    val createdAt: String,
    val isBase: Boolean = false
)